import {
  REPORTS,
  REPORTS_SUCCESS,
  REPORTS_FAILURE,
} from "../actionTypes";

export const reports = (payload) => ({
  type: REPORTS,
  payload,
});

export const reportsSuccess = (payload) => ({
  type: REPORTS_SUCCESS,
  payload,
});

export const reportsFailure = () => ({
  type: REPORTS_FAILURE,
});
